import { Box, Button, Chip } from "@mui/material";
import React from "react";
import Flx from "../../../../components/layout/Flx";
import Txt from "../../../../components/typography/Txt";
import { grey } from "@mui/material/colors";

const DetailSection = ({
  title,
  children,
  count,
  action,
  actionLabel,
  py = 2,
  headerMb = 1,
  pt,
  pb,
  endContent,
  sx,
}) => (
  <Box
    sx={{
      px: 1.5,

      ...sx,
    }}
  >
    <Flx
      ac
      jb
      sx={{
        //
        mb: headerMb,
        // mb: 1.5,
      }}
    >
      <Flx fw jb wrap ac gap={1}>
        <Flx ac gap={1}>
          <Txt
            sx={{
              // fontSize: "13px",
              fontSize: "12.5px",
              fontWeight: 700,
              // color: grey[400],
              textTransform: "uppercase",
              letterSpacing: ".5px",
              // letterSpacing: "1px",
            }}
          >
            {title}
          </Txt>

          {count !== undefined && (
            <Chip
              label={count}
              size="small"
              sx={{
                height: 18,
                fontSize: "10px",
                fontWeight: 700,
                bgcolor: grey[100],
                color: grey[600],
              }}
            />
          )}
        </Flx>
        {endContent}
      </Flx>
      {action && (
        <Button
          size="small"
          variant="text"
          onClick={action}
          sx={{ fontSize: "11px", minWidth: "auto" }}
        >
          {actionLabel || "View All"}
        </Button>
      )}
    </Flx>
    {children}
  </Box>
);

export default DetailSection;
